<template>
    <Card :title="$t('labels.arrival_declaration_status')">
        <div class="card-body">
            <ArrivalDeclarationStatusFieldsetGroup v-if="arrivalDeclarationStatus" :arrival-declaration-status="arrivalDeclarationStatus" />
        </div>
        <div class="card-footer d-flex justify-content-end">
            <AppButton size="sm" color="light" @click="remove" class="mr-2">
                <span>{{ $t('buttons.delete') }}</span>
            </AppButton>
            <AppButton size="sm" color="teal" @click="update">
                <span>{{ $t('buttons.edit') }}</span>
            </AppButton>
        </div>
    </Card>
</template>
<script>
import Card from '../../../../components/new/CardComponent.vue';
import AppButton from '../../../../components/new/button/AppButton.vue';
import ArrivalDeclarationStatusFieldsetGroup from './fieldsets/ArrivalDeclarationStatusFieldsetGroup.vue';
import { httpClient } from '../../../../services/HttpClient';
import MessageNotificator from '../../../../services/MessageNotificator.js';
export default {
    name: "EditArrivalDeclarationStatusPage",
    components: {
        Card, AppButton, ArrivalDeclarationStatusFieldsetGroup
    },
    data() {
        return {
            arrivalDeclarationStatus: null
        }
    },
    methods: {
        async fetchArrivalDeclarationStatus() {
            await httpClient.get(`/management/arrival-declaration-statuses/${this.$route.params.arrivalDeclarationStatusUuid}`).then((response) => {
                this.arrivalDeclarationStatus = response.data.data
            });
        },
        async update() {
            await httpClient.put(`/management/arrival-declaration-statuses/${this.arrivalDeclarationStatus.uuid}`, {
                name: this.arrivalDeclarationStatus.name,
                color: this.arrivalDeclarationStatus.color,
                type: this.arrivalDeclarationStatus.type,
                order: this.arrivalDeclarationStatus.order
            }).then((response) => {
                this.arrivalDeclarationStatus = response.data.data
                new MessageNotificator().success(this.$t('alerts.success'));
            });
        },
        remove() {
            new MessageNotificator().confirm(this.$t('alerts.delete_arrival_declaration_status'), async () => {
                await httpClient.delete(`/management/arrival-declaration-statuses/${this.arrivalDeclarationStatus.uuid}`).then(() => {
                    this.$router.push({ name: 'IndexArrivalDeclarationStatusPage' });
                });
            });
        }
    },
    mounted() {
        this.fetchArrivalDeclarationStatus();
    }
}
</script>
